var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('div',{staticClass:"windowmain"},[_c('iframe',{attrs:{"src":_vm.href+'/userserver/rest/mobileTerminal/retrieveName/etps',"width":"100%","height":"100%"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }